import globalTypes from "reducers/types/global";
import gaEventTracker, { events } from "util/gaEventTracker";

export const types = {
    LOAD_SENT_REQUESTS_REQUEST: "debin/LOAD_SENT_REQUESTS_REQUEST",
    LOAD_SENT_REQUESTS_FAILURE: "debin/LOAD_SENT_REQUESTS_FAILURE",
    LOAD_SENT_REQUESTS_SUCCESS: "debin/LOAD_SENT_REQUESTS_SUCCESS",
    SEND_ADD_ACCOUNT_ACTION_REQUEST: "debin/SEND_ADD_ACCOUNT_ACTION_REQUEST",
    SEND_ADD_ACCOUNT_ACTION_FAILURE: "debin/SEND_ADD_ACCOUNT_ACTION_FAILURE",
    SEND_ADD_ACCOUNT_ACTION_SUCCESS: "debin/SEND_ADD_ACCOUNT_ACTION_SUCCESS",
    SET_DEBIN_TO_CANCEL: "debin/SET_DEBIN_TO_CANCEL",
    SET_ACCOUNT_TO_CHANGE: "debin/SET_ACCOUNT_TO_CHANGE",
    CANCEL_DEBIN_REQUEST: "debin/CANCEL_DEBIN_REQUEST",
    CANCEL_DEBIN_FAILURE: "debin/CANCEL_DEBIN_FAILURE",
    CANCEL_DEBIN_SUCCESS: "debin/CANCEL_DEBIN_SUCCESS",
    LOAD_INCOMING_DEBIN_LIST_REQUEST: "debin/LOAD_INCOMING_DEBIN_LIST_REQUEST",
    LOAD_INCOMING_DEBIN_LIST_FAILURE: "debin/LOAD_INCOMING_DEBIN_LIST_FAILURE",
    LOAD_INCOMING_DEBIN_LIST_SUCCESS: "debin/LOAD_INCOMING_DEBIN_LIST_SUCCESS",
    REMOVE_SELLER_ACCOUNT_REQUEST: "debin/REMOVE_SELLER_ACCOUNT_REQUEST",
    REMOVE_SELLER_ACCOUNT_FAILURE: "debin/REMOVE_SELLER_ACCOUNT_FAILURE",
    REMOVE_SELLER_ACCOUNT_SUCCESS: "debin/REMOVE_SELLER_ACCOUNT_SUCCESS",
    ACCEPT_INCOMING_DEBIN_PRE_REQUEST: "debin/ACCEPT_INCOMING_DEBIN_PRE_REQUEST",
    ACCEPT_INCOMING_DEBIN_PRE_REQUEST_REDIRECT: "debin/ACCEPT_INCOMING_DEBIN_PRE_REQUEST_REDIRECT",
    ACCEPT_INCOMING_DEBIN_PRE_FAILURE: "debin/ACCEPT_INCOMING_DEBIN_PRE_FAILURE",
    ACCEPT_INCOMING_DEBIN_PRE_SUCCESS: "debin/ACCEPT_INCOMING_DEBIN_PRE_SUCCESS",
    ACCEPT_INCOMING_DEBIN_SEND_REQUEST: "debin/ACCEPT_INCOMING_DEBIN_SEND_REQUEST",
    ACCEPT_INCOMING_DEBIN_SEND_FAILURE: "debin/ACCEPT_INCOMING_DEBIN_SEND_FAILURE",
    ACCEPT_INCOMING_DEBIN_SEND_SUCCESS: "debin/ACCEPT_INCOMING_DEBIN_SEND_SUCCESS",
    DECLINE_INCOMING_DEBIN_SEND_REQUEST: "debin/DECLINE_INCOMING_DEBIN_SEND_REQUEST",
    DECLINE_INCOMING_DEBIN_FAILURE: "debin/DECLINE_INCOMING_DEBIN_FAILURE",
    DECLINE_INCOMING_DEBIN_SUCCESS: "debin/DECLINE_INCOMING_DEBIN_SUCCESS",
    DECLINE_FIXED_TERM_SEND_REQUEST: "debin/DECLINE_FIXED_TERM_SEND_REQUEST",
    SET_CBU_LIST: "debin/SET_CBU_LIST",
    ADD_TO_CBU_LIST: "debin/ADD_TO_CBU_LIST",
    DEBIN_SEND_REQUEST: "debin/DEBIN_SEND_REQUEST",
    DEBIN_SEND_FAILURE: "debin/DEBIN_SEND_FAILURE",
    DEBIN_SEND_SUCCESS: "debin/DEBIN_SEND_SUCCESS",
    SEND_DEBIN_PRE_REQUEST: "debin/SEND_DEBIN_PRE_REQUEST",
    SEND_DEBIN_PRE_FAILURE: "debin/SEND_DEBIN_PRE_FAILURE",
    SEND_DEBIN_PRE_SUCCESS: "debin/SEND_DEBIN_PRE_SUCCESS",
    LOAD_CONFIRM_INCOMING_DEBIN: "debin/LOAD_CONFIRM_INCOMING_DEBIN",
    LOAD_ACCOUNT_NAME: "debin/LOAD_ACCOUNT_NAME",
    SEND_CREDIN_PRE_REQUEST: "debin/SEND_CREDIN_PRE_REQUEST",
    SEND_CREDIN_PRE_FAILURE: "debin/SEND_CREDIN_PRE_FAILURE",
    SEND_CREDIN_PRE_SUCCESS: "debin/SEND_CREDIN_PRE_SUCCESS",
    SEND_CREDIN_REQUEST: "debin/SEND_CREDIN_REQUEST",
    CREDIN_SEND_FAILURE: "debin/CREDIN_SEND_FAILURE",
    CREDIN_SEND_SUCCESS: "debin/CREDIN_SEND_SUCCESS",
    LOAD_CONFIRM_CREDIN: "debin/LOAD_CONFIRM_CREDIN",
    GET_SELLER_DEBIN_DETAIL_REQUEST: "debin/GET_SELLER_DEBIN_DETAIL_REQUEST",
    GET_SELLER_DEBIN_DETAIL_FAILURE: "debin/GET_SELLER_DEBIN_DETAIL_FAILURE",
    GET_SELLER_DEBIN_DETAIL_SUCCESS: "debin/GET_SELLER_DEBIN_DETAIL_SUCCESS",
    DEBIN_PRE_REQUEST: "debin/DEBIN_PRE_REQUEST",
    DEBIN_PRE_SUCCESS: "debin/DEBIN_PRE_SUCCESS",
    DEBIN_PRE_FAILURE: "debin/DEBIN_PRE_FAILURE",
    DEBIN_SELLER_CUIT: "debin/DEBIN_SELLER_CUIT",
    LOAD_DEBIN_SELLER: "debin/LOAD_DEBIN_SELLER",
    CLEAN_DEBIN_SELLER: "debin/CLEAN_DEBIN_SELLER",
    SET_DEBIN_PRESTACION: "debin/SET_DEBIN_PRESTACION",
    CLEAN_DEBIN_PRESTACION: "debin/CLEAN_DEBIN_PRESTACION",
    RELATE_BUYER_RECURRENCY: "debin/RELATE_BUYER_RECURRENCY",
    DEBIN_RECURRENCIES: "debin/DEBIN_RECURRENCIES",
    SET_DEBIN_RECURRENCIES: "debin/SET_DEBIN_RECURRENCIES",
    CLEAN_DEBIN_RECURRENCIES: "debin/CLEAN_DEBIN_RECURRENCIES",
    SET_RECURRENCY_FILTERS: "debin/SET_RECURRENCY_FILTERS",
    SET_RECURRENCY_DEBIN_ACTION: "debin/SET_RECURRENCY_DEBIN_ACTION",
    SET_UPDATE_RECURRENCY_STATE: "debin/SET_UPDATE_RECURRENCY_STATE",
    CLEAR_REQUEST_DATA: "debin/CLEAR_REQUEST_DATA",
    SET_DEBIN_SELLER: "debin/SET_DEBIN_SELLER",
    SET_IS_BACK_FROM_SUMMARY: "debin/SET_IS_BACK_FROM_SUMMARY",
    CLEAN_IS_BACK_FROM_SUMMARY: "debin/CLEAN_IS_BACK_FROM_SUMMARY",
    SET_PAGE_TO_GO_BACK: "debin/SET_PAGE_TO_GO_BACK",
    SELECT_BENEFICIARY: "debin/SELECT_BENEFICIARY",
    CLEAN_DEBIN_BENEFICIARY: "debin/CLEAN_DEBIN_BENEFICIARY",
    DEBIN_TICKET_SUCCESS: "debin/EMIT_DEBIN_SUCCESS",
    CLEAN_DEBIN_TICKET: "debin/CLEAN_DEBIN_TICKET",
    ADD_NEW_VENDOR_REQUEST: "debin/ADD_NEW_VENDOR_REQUEST",
    ADD_NEW_VENDOR_REQUEST_SUCCESS: "debin/ADD_NEW_VENDOR_REQUEST_SUCCESS",
    ADD_NEW_VENDOR_REQUEST_FAILURE: "debin/ADD_NEW_VENDOR_REQUEST_FAILURE",
    REMOVE_VENDOR_REQUEST: "debin/REMOVE_VENDOR_REQUEST",
    REMOVE_VENDOR_REQUEST_SUCCESS: "debin/REMOVE_VENDOR_REQUEST_SUCCESS",
    REMOVE_VENDOR_REQUEST_FAILURE: "debin/REMOVE_VENDOR_REQUEST_FAILURE",
    CLEAN_DEBIN_STATUS: "debin/CLEAN_DEBIN_STATUS",
    SET_SOLICIT_DEBIN: "debin/SET_SOLICIT_DEBIN",
    SET_DETAIL: "debin/SET_DETAIL",
    GET_ACCOUNT_INFO_BY_CBU_CVU_ALIAS: "debin/GET_ACCOUNT_INFO_BY_CBU_CVU_ALIAS",
    GET_ACCOUNT_INFO_BY_CBU_CVU_ALIAS_APPLICANT: "debin/GET_ACCOUNT_INFO_BY_CBU_CVU_ALIAS_APPLICANT",
    DEBIN_TICKET_CREDENTIAL_REQUEST: "debin/DEBIN_TICKET_CREDENTIAL_REQUEST",
    DEBIN_TICKET_CREDENTIAL_SUCCESS: "debin/DEBIN_TICKET_CREDENTIAL_SUCCESS",

    SCHEDULED_DEBINS_LIST_FAILURE: "debin/SCHEDULED_DEBINS_LIST_FAILURE",
    SCHEDULED_DEBINS_LIST_SUCCESS: "debin/SCHEDULED_DEBINS_LIST_SUCCESS",
    SCHEDULED_DEBINS_LIST_REQUEST: "debin/SCHEDULED_DEBINS_LIST_REQUEST",

    SET_SCHEDULED_DEBIN_SELECTED: "debin/SET_SCHEDULED_DEBIN_SELECTED",

    ACCEPT_SCHEDULED_DEBIN_REQUEST: "debin/ACCEPT_SCHEDULED_DEBIN_REQUEST",
    ACCEPT_SCHEDULED_DEBIN_SUCCESS: "debin/ACCEPT_SCHEDULED_DEBIN_SUCCESS",
    ACCEPT_SCHEDULED_DEBIN_FAILURE: "debin/ACCEPT_SCHEDULED_DEBIN_FAILURE",

    REJECT_SCHEDULED_DEBIN_REQUEST: "debin/REJECT_SCHEDULED_DEBIN_REQUEST",
    REJECT_SCHEDULED_DEBIN_SUCCESS: "debin/REJECT_SCHEDULED_DEBIN_SUCCESS",
    REJECT_SCHEDULED_DEBIN_FAILURE: "debin/REJECT_SCHEDULED_DEBIN_FAILURE",

    PAUSE_SCHEDULED_DEBIN_REQUEST: "debin/PAUSE_SCHEDULED_DEBIN_REQUEST",
    PAUSE_SCHEDULED_DEBIN_SUCCESS: "debin/PAUSE_SCHEDULED_DEBIN_SUCCESS",
    PAUSE_SCHEDULED_DEBIN_FAILURE: "debin/PAUSE_SCHEDULED_DEBIN_FAILURE",

    CANCEL_SCHEDULED_DEBIN_REQUEST: "debin/CANCEL_SCHEDULED_DEBIN_REQUEST",
    CANCEL_SCHEDULED_DEBIN_SUCCESS: "debin/CANCEL_SCHEDULED_DEBIN_SUCCESS",
    CANCEL_SCHEDULED_DEBIN_FAILURE: "debin/CANCEL_SCHEDULED_DEBIN_FAILURE",

    ACTIVATE_SCHEDULED_DEBIN_REQUEST: "debin/ACTIVATE_SCHEDULED_DEBIN_REQUEST",
    ACTIVATE_SCHEDULED_DEBIN_SUCCESS: "debin/ACTIVATE_SCHEDULED_DEBIN_SUCCESS",
    ACTIVATE_SCHEDULED_DEBIN_FAILURE: "debin/ACTIVATE_SCHEDULED_DEBIN_FAILURE",

    SET_DEBIN_TO_CHARGE_BACK: "debin/SET_DEBIN_TO_CHARGE_BACK",
    CHARGE_BACK_REQUEST: "debin/CHARGE_BACK_REQUEST",

    CHARGE_BACK_TRXPL_REQUEST: "debin/CHARGE_BACK_TRXPL_REQUEST",
};

export const INITIAL_STATE = {
    fetching: false,
    fetchingPreview: false,
    dateFrom: null,
    dateTo: null,
    titular: null,
    recipients: null,
    id: null,
    status: null,
    sentRequests: [],
    accountToChange: null,
    changeToStatus: null,
    accountAction: null,
    cbuList: [],
    summary: null,
    concepts: [],
    accounts: [],
    seller: {},
    prestaciones: [],
    debinPrestacion: {},
    solicitDebin: {},
    debinRecurrency: [],
    filterRecurrencyList: {
        // account: "TODOS",
        // seller: "",
        // status: "TODOS",
        // paginas_totales: 1,
    },
    recurrencyDebinAction: {},
    pageNumber: 1,
    totalPages: 1,
    isBackFromSummary: false,
    pageToGoBack: null,
    beneficiary: null,
    debinTicket: { status: "", idTransaction: "" },
    addVendorAccount: { status: "" },
    debinRequiredCredentials: [],
    hasMoreData: false,
    scheduledDebins: [],
    scheduledDebin: null,
    debinToChargeBack: null,
};

export default (state = INITIAL_STATE, action = {}) => {
    const {
        sentRequests,
        filters = {},
        accountToChange,
        otp,
        debinToCancel,
        debinDetail,
        cbuList,
        newCbu,
        debinSeller,
        recipients,
        id,
        summary,
        accountName,
        concepts,
        accounts,
        pageToGoBack,
        beneficiary,
        debinTicket,
        addVendorAccount,
        solicitDebin,
        idAccount,
        expirationDate,
        concept,
        debinRequiredCredentials,
        scheduledDebin,
        debinToChargeBack,
    } = action;
    switch (action.type) {
        case types.SET_RECURRENCY_DEBIN_ACTION:
            return {
                ...state,
                recurrencyDebinAction: action.debin,
            };
        case types.DEBIN_RECURRENCIES:
            return {
                ...state,
                filterRecurrencyList: { ...state.filterRecurrencyList, ...action.formFilter },
            };
        case types.SET_RECURRENCY_FILTERS:
            return {
                ...state,
                filterRecurrencyList: { ...state.filterRecurrencyList, ...action.filters },
            };
        case types.CLEAN_DEBIN_RECURRENCIES:
            return {
                ...state,
                debinRecurrency: [],
                // filterRecurrencyList: { ...state.filterRecurrencyList, paginas_totales: 1 },
                filterRecurrencyList: { ...state.filterRecurrencyList },
            };
        case types.SET_DEBIN_RECURRENCIES:
            return {
                ...state,
                debinRecurrency: action.debinRecurrency,
                // debinRecurrency: action.debinRecurrency && JSON.parse(action.debinRecurrency),
                filterRecurrencyList: { ...state.filterRecurrencyList },
                // filterRecurrencyList: { ...state.filterRecurrencyList, paginas_totales: action.paginas_totales },
            };
        case types.SET_DEBIN_PRESTACION:
            return {
                ...state,
                debinPrestacion: action.debinPrestacion,
            };
        case types.CLEAN_DEBIN_PRESTACION:
            return {
                ...state,
                debinPrestacion: {},
                beneficiary: null,
                creditCbu: null,
                selectBeneficiaryApplicant: null,
                seller: {},
            };
        case types.LOAD_DEBIN_SELLER:
            return {
                ...state,
                seller: action.seller && JSON.parse(action.seller),
                fetching: false,
                prestaciones: action.prestaciones && JSON.parse(action.prestaciones),
            };
        case types.CLEAN_DEBIN_SELLER:
            return {
                ...state,
                seller: {},
                prestaciones: [],
                fetching: false,
            };
        case types.LOAD_SENT_REQUESTS_REQUEST:
            return {
                ...state,
                ...filters,
                fetching: true,
            };
        case types.LOAD_SENT_REQUESTS_FAILURE:
            return {
                ...state,
                cbuSelected: false,
            };
        case types.SET_CBU_LIST:
            return {
                ...state,
                cbuList,
            };
        case types.ADD_TO_CBU_LIST:
            return {
                ...state,
                cbuList: [...state.cbuList, newCbu],
            };
        case types.LOAD_SENT_REQUESTS_SUCCESS:
            return {
                ...state,
                fetching: false,
                sentRequests,
                totalPages: action.totalPages,
            };
        case types.SEND_ADD_ACCOUNT_ACTION_REQUEST:
            return {
                ...state,
                accountToChange,
                fetching: true,
                otp,
            };
        case types.SEND_ADD_ACCOUNT_ACTION_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.SEND_ADD_ACCOUNT_ACTION_SUCCESS:
            return {
                ...state,
                fetching: false,
            };
        case types.SET_ACCOUNT_TO_CHANGE:
            return {
                ...state,
                accountToChange,
            };
        case types.SET_DEBIN_TO_CANCEL:
            return {
                ...state,
                debinToCancel,
            };
        case types.CANCEL_DEBIN_REQUEST:
            return {
                ...state,
                otp,
                debinToCancel,
                fetching: true,
            };
        case types.CANCEL_DEBIN_SUCCESS:
            return {
                ...state,
                fetching: false,
            };
        case types.CANCEL_DEBIN_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.LOAD_INCOMING_DEBIN_LIST_REQUEST:
            return {
                ...state,
                ...filters,
                fetching: true,
            };
        case types.LOAD_INCOMING_DEBIN_LIST_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.LOAD_INCOMING_DEBIN_LIST_SUCCESS:
            return {
                ...state,
                sentRequests,
                fetching: false,
                totalPages: action.totalPages,
            };
        case types.REMOVE_SELLER_ACCOUNT_REQUEST:
            return {
                ...state,
                fetching: true,
                accountToChange,
            };
        case types.REMOVE_SELLER_ACCOUNT_FAILURE:
            return {
                ...state,
                fetching: false,
                accountToChange: null,
            };
        case types.REMOVE_SELLER_ACCOUNT_SUCCESS:
            return {
                ...state,
                fetching: false,
                accountToChange: null,
            };
        case types.ACCEPT_INCOMING_DEBIN_PRE_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.ACCEPT_INCOMING_DEBIN_PRE_REQUEST_REDIRECT:
            return {
                ...state,
                fetching: true,
            };
        case types.ACCEPT_INCOMING_DEBIN_PRE_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.ACCEPT_INCOMING_DEBIN_PRE_SUCCESS:
            return {
                ...state,
                debinDetail,
                fetching: false,
            };
        case types.DEBIN_SEND_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.DEBIN_SEND_SUCCESS:
            return {
                ...state,
                debinTicket,
                fetching: false,
            };
        case types.SEND_CREDIN_REQUEST:
            return {
                ...state,
                debinSeller,
                fetching: true,
            };
        case types.CREDIN_SEND_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.CREDIN_SEND_SUCCESS:
            return {
                ...state,
                fetching: false,
                summary,
            };
        case types.ACCEPT_INCOMING_DEBIN_SEND_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.ACCEPT_INCOMING_DEBIN_SEND_FAILURE:
        case types.ACCEPT_INCOMING_DEBIN_SEND_SUCCESS:
            return {
                ...state,
                fetching: false,
                pageToGoBack: "/payments/payDebin",
            };
        case types.SEND_DEBIN_PRE_REQUEST:
            return {
                ...state,
                expirationDate,
                concept,
                idAccount,
                recipients,
                fetchingPreview: true,
            };
        case types.SEND_DEBIN_PRE_SUCCESS:
            return {
                ...state,
                fetchingPreview: false,
                recipients,
            };
        case types.SEND_DEBIN_PRE_FAILURE:
            return {
                ...state,
                fetchingPreview: false,
            };
        case types.LOAD_CONFIRM_INCOMING_DEBIN:
            return {
                ...state,
                summary,
            };
        case types.LOAD_ACCOUNT_NAME:
            return {
                ...state,
                accountName,
            };
        case types.CLEAR_REQUEST_DATA:
            return {
                ...state,
                fetching: false,
            };
        case types.SEND_CREDIN_PRE_REQUEST:
            return {
                ...state,
                debinSeller,
                fetching: true,
            };
        case types.SEND_CREDIN_PRE_SUCCESS:
            return {
                ...state,
                fetching: false,
                recipients,
                id,
            };
        case types.SEND_CREDIN_PRE_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.GET_SELLER_DEBIN_DETAIL_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.GET_SELLER_DEBIN_DETAIL_SUCCESS:
            return {
                ...state,
                debinDetail,
                fetching: false,
            };
        case types.GET_SELLER_DEBIN_DETAIL_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.LOAD_CONFIRM_CREDIN:
            return {
                ...state,
                summary,
            };
        case types.DEBIN_PRE_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.DEBIN_PRE_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.DEBIN_PRE_SUCCESS:
            return {
                ...state,
                concepts,
                accounts,
                fetching: false,
            };
        case types.DEBIN_SELLER_CUIT:
            return {
                ...state,
                fetching: true,
            };
        case types.SET_DEBIN_SELLER:
            return {
                ...state,
                debinSeller,
                cbuList,
                recipients: debinSeller?.recipients,
            };
        case types.SET_IS_BACK_FROM_SUMMARY:
            return {
                ...state,
                isBackFromSummary: true,
            };
        case types.CLEAN_IS_BACK_FROM_SUMMARY:
            return {
                ...state,
                isBackFromSummary: false,
            };

        case types.SET_PAGE_TO_GO_BACK:
            return {
                ...state,
                pageToGoBack,
            };

        case globalTypes.RESET_SELECTED_ELEMENTS:
        case globalTypes.CLEAN_UP:
            return INITIAL_STATE;
        case types.SELECT_BENEFICIARY:
            return {
                ...state,
                beneficiary,
            };
        case types.CLEAN_DEBIN_BENEFICIARY:
            return {
                ...state,
                beneficiary: null,
            };
        case types.DEBIN_TICKET_SUCCESS:
            return {
                ...state,
                debinTicket,
            };
        case types.CLEAN_DEBIN_TICKET:
            return {
                ...state,
                debinTicket: { status: "", idTransaction: "" },
            };
        case types.ADD_NEW_VENDOR_REQUEST:
            return {
                ...state,
                addVendorAccount: { status: "" },
            };
        case types.ADD_NEW_VENDOR_REQUEST_FAILURE:
            return {
                ...state,
                addVendorAccount,
            };
        case types.ADD_NEW_VENDOR_REQUEST_SUCCESS:
            return {
                ...state,
                addVendorAccount,
            };
        case types.REMOVE_VENDOR_REQUEST:
            return {
                ...state,
            };
        case types.REMOVE_VENDOR_REQUEST_SUCCESS:
            return {
                ...state,
            };
        case types.REMOVE_VENDOR_REQUEST_FAILURE:
            return {
                ...state,
            };
        case types.CLEAN_DEBIN_STATUS:
            return {
                ...state,
                addVendorAccount: { status: "" },
            };
        case types.SET_SOLICIT_DEBIN:
            return {
                ...state,
                solicitDebin,
            };
        case types.SET_DETAIL:
            return {
                ...state,
                debinDetail,
            };
        case types.DEBIN_TICKET_CREDENTIAL_SUCCESS:
            return {
                ...state,
                fetching: false,
                debinRequiredCredentials,
                debinTicket: { status: "", idTransaction: "" },
            };

        case types.SCHEDULED_DEBINS_LIST_REQUEST:
            return {
                ...state,
                fetching: true,
                filterRecurrencyList: { ...state.filterRecurrencyList, ...action.formFilter },
            };
        case types.SCHEDULED_DEBINS_LIST_FAILURE:
            return {
                ...state,
                fetching: false,
                scheduledDebins: [],
                scheduledDebin: null,
                filterRecurrencyList: { ...state.filterRecurrencyList },
            };
        case types.SCHEDULED_DEBINS_LIST_SUCCESS:
            return {
                ...state,
                fetching: false,
                scheduledDebins: action.scheduledDebins,
                scheduledDebin: null,
                filterRecurrencyList: { ...state.filterRecurrencyList },
            };

        case types.SET_SCHEDULED_DEBIN_SELECTED:
            return {
                ...state,
                scheduledDebin,
            };

        case types.ACCEPT_SCHEDULED_DEBIN_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.ACCEPT_SCHEDULED_DEBIN_SUCCESS:
            return {
                ...state,
                fetching: false,
                scheduledDebin: null,
            };
        case types.ACCEPT_SCHEDULED_DEBIN_FAILURE:
            return {
                ...state,
                fetching: false,
            };

        case types.REJECT_SCHEDULED_DEBIN_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.REJECT_SCHEDULED_DEBIN_SUCCESS:
            return {
                ...state,
                fetching: false,
                scheduledDebin: null,
            };
        case types.REJECT_SCHEDULED_DEBIN_FAILURE:
            return {
                ...state,
                fetching: false,
            };

        case types.PAUSE_SCHEDULED_DEBIN_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.PAUSE_SCHEDULED_DEBIN_SUCCESS:
            return {
                ...state,
                fetching: false,
                scheduledDebin: null,
            };
        case types.PAUSE_SCHEDULED_DEBIN_FAILURE:
            return {
                ...state,
                fetching: false,
            };

        case types.CANCEL_SCHEDULED_DEBIN_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.CANCEL_SCHEDULED_DEBIN_SUCCESS:
            return {
                ...state,
                fetching: false,
                scheduledDebin: null,
            };
        case types.CANCEL_SCHEDULED_DEBIN_FAILURE:
            return {
                ...state,
                fetching: false,
            };

        case types.ACTIVATE_SCHEDULED_DEBIN_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.ACTIVATE_SCHEDULED_DEBIN_SUCCESS:
            return {
                ...state,
                fetching: false,
                scheduledDebin: null,
            };
        case types.ACTIVATE_SCHEDULED_DEBIN_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.SET_DEBIN_TO_CHARGE_BACK:
            return {
                ...state,
                debinToChargeBack,
            };

        default:
            return state;
    }
};

export const actions = {
    loadSentRequests: (filters) => ({
        type: types.LOAD_SENT_REQUESTS_REQUEST,
        filters,
    }),
    setCbuSelected: (cbuList) => ({
        type: types.SET_CBU_LIST,
        cbuList,
    }),
    setAccountToChange: (accountToChange) => ({
        type: types.SET_ACCOUNT_TO_CHANGE,
        accountToChange,
    }),
    sendAddAccountChange: (accountToChange, userId, otp, formikBag) => ({
        type: types.SEND_ADD_ACCOUNT_ACTION_REQUEST,
        accountToChange,
        userId,
        otp,
        formikBag,
    }),
    debinToCancel: (debinToCancel) => ({
        type: types.SET_DEBIN_TO_CANCEL,
        debinToCancel,
    }),
    cancelRequest: (debinToCancel, formikBag, otp) => ({
        type: types.CANCEL_DEBIN_REQUEST,
        debinToCancel,
        formikBag,
        otp,
    }),
    loadIncomingRequests: (filters) => ({
        type: types.LOAD_INCOMING_DEBIN_LIST_REQUEST,
        filters,
    }),
    removeSellerAccount: (accountToChange) => ({
        type: types.REMOVE_SELLER_ACCOUNT_REQUEST,
        accountToChange,
    }),
    acceptIncomingRequestPre: (idDebin, isDetail) => ({
        type: types.ACCEPT_INCOMING_DEBIN_PRE_REQUEST,
        idDebin,
        isDetail,
    }),
    acceptIncomingRequestPreRedirect: (idDebin, route) => ({
        type: types.ACCEPT_INCOMING_DEBIN_PRE_REQUEST_REDIRECT,
        idDebin,
        route,
    }),
    generateCredin: (otp, debinSeller, recipients, id, formikBag) => ({
        type: types.SEND_CREDIN_REQUEST,
        debinSeller,
        recipients,
        otp,
        id,
        formikBag,
    }),
    getDebinDetail: (idDebin) => ({
        type: types.GET_SELLER_DEBIN_DETAIL_REQUEST,
        idDebin,
    }),
    sendDebinRequest: (newDebinRequest, formikBag, credentialType) => ({
        type: types.DEBIN_SEND_REQUEST,
        newDebinRequest,
        formikBag,
        credentialType,
    }),
    clearRequestData: () => ({ type: types.CLEAR_REQUEST_DATA }),
    preGenerateCredin: (debinSeller, cbuList) => ({
        type: types.SEND_CREDIN_PRE_REQUEST,
        debinSeller,
        cbuList,
    }),
    sendDebinPreRequest: ({ expirationDate, concept, idAccount, recipients }) => ({
        type: types.SEND_DEBIN_PRE_REQUEST,
        expirationDate,
        concept,
        idAccount,
        recipients,
    }),
    acceptIncomingRequestSend: (debin, formikBag, credentialType) => ({
        type: types.ACCEPT_INCOMING_DEBIN_SEND_REQUEST,
        debin,
        formikBag,
        credentialType,
    }),
    declineIncomingRequestSend: (debin, formikBag, credentialType) => ({
        type: types.DECLINE_INCOMING_DEBIN_SEND_REQUEST,
        debin,
        formikBag,
        credentialType,
    }),
    declineFixedTermRequestSend: (currency, amount, idDebin, otp, account, userId, formikBag) => ({
        type: types.DECLINE_FIXED_TERM_SEND_REQUEST,
        currency,
        amount,
        idDebin,
        otp,
        account,
        userId,
        formikBag,
    }),
    loadConfirmIncomingDebin: (summary) => ({
        type: types.LOAD_CONFIRM_INCOMING_DEBIN,
        summary,
    }),
    loadAccountName: (accountName) => ({
        type: types.LOAD_ACCOUNT_NAME,
        accountName,
    }),
    loadConfirmCredin: (summary) => ({
        type: types.LOAD_CONFIRM_CREDIN,
        summary,
    }),
    debinPreActivity: () => ({
        type: types.DEBIN_PRE_REQUEST,
    }),
    debinSeller: (cuit, setSubmitting) => ({
        type: types.DEBIN_SELLER_CUIT,
        seller: cuit,
        setSubmitting,
    }),
    cleanDebinSeller: () => ({
        type: types.CLEAN_DEBIN_SELLER,
    }),
    setdebinPrestacionData: (debinPrestacion) => ({
        type: types.SET_DEBIN_PRESTACION,
        debinPrestacion,
    }),
    relateBuyerToRecurrency: (debinPrestacion, setSubmitting) => {
        gaEventTracker.triggerEvent(events.debin_adherir_recurrencia_enviar());
        return {
            type: types.RELATE_BUYER_RECURRENCY,
            debinPrestacion,
            setSubmitting,
        };
    },
    getDebinRecurrencies: (formFilter) => ({
        type: types.DEBIN_RECURRENCIES,
        formFilter,
    }),
    setRecurrencyDebinFilters: (filters) => ({
        type: types.SET_RECURRENCY_FILTERS,
        filters,
    }),
    setRecurrencyDebinAction: (debin) => ({
        type: types.SET_RECURRENCY_DEBIN_ACTION,
        debin,
    }),
    updateRecurrencyState: (debin, formikBag, credentialType) => ({
        type: types.SET_UPDATE_RECURRENCY_STATE,
        debin,
        formikBag,
        credentialType,
    }),
    setDebinSeller: (debinSeller, cbuList) => ({
        type: types.SET_DEBIN_SELLER,
        debinSeller,
        cbuList,
    }),
    setIsBackFromSummary: (page) => ({
        type: types.SET_IS_BACK_FROM_SUMMARY,
        page,
    }),
    cleanIsBackFromSummary: (page) => ({
        type: types.CLEAN_IS_BACK_FROM_SUMMARY,
        page,
    }),

    setPageToGoBack: (pageToGoBack) => ({
        type: types.SET_PAGE_TO_GO_BACK,
        pageToGoBack,
    }),
    setBeneficiary: (beneficiary) => ({
        type: types.SELECT_BENEFICIARY,
        beneficiary,
    }),
    cleanDebinTicket: () => ({
        type: types.CLEAN_DEBIN_TICKET,
    }),
    addNewVendorAccount: (idAccount) => ({
        type: types.ADD_NEW_VENDOR_REQUEST,
        idAccount,
    }),
    removeVendorAccount: (idAccount) => ({
        type: types.REMOVE_VENDOR_REQUEST,
        idAccount,
    }),
    cleanDebinStatus: () => ({
        type: types.CLEAN_DEBIN_STATUS,
    }),
    setSolicitDebin: (solicitDebin) => ({
        type: types.SET_SOLICIT_DEBIN,
        solicitDebin,
    }),
    setDetail: (debinDetail) => ({
        type: types.SET_DETAIL,
        debinDetail,
    }),
    getAccountInfoByCbuCbuCvuAlias: (creditCbu, formikBag) => ({
        type: types.GET_ACCOUNT_INFO_BY_CBU_CVU_ALIAS,
        creditCbu,
        formikBag,
    }),
    getAccountInfoByCbuCbuCvuAliasApplicant: (creditCbu, selectBeneficiaryApplicant) => ({
        type: types.GET_ACCOUNT_INFO_BY_CBU_CVU_ALIAS_APPLICANT,
        creditCbu,
        selectBeneficiaryApplicant,
    }),
    fetchCredentialGroup: () => ({
        type: types.DEBIN_TICKET_CREDENTIAL_REQUEST,
    }),

    scheduledDebinList: (formFilter) => ({
        type: types.SCHEDULED_DEBINS_LIST_REQUEST,
        formFilter,
    }),

    setScheduledDebin: (scheduledDebin) => ({
        type: types.SET_SCHEDULED_DEBIN_SELECTED,
        scheduledDebin,
    }),

    acceptScheduledDebinSend: (params, formikBag, credentialType) => ({
        type: types.ACCEPT_SCHEDULED_DEBIN_REQUEST,
        params,
        formikBag,
        credentialType,
    }),

    rejectScheduledDebinSend: (params, formikBag, credentialType) => ({
        type: types.REJECT_SCHEDULED_DEBIN_REQUEST,
        params,
        formikBag,
        credentialType,
    }),

    pauseScheduledDebinSend: (params, formikBag, credentialType) => ({
        type: types.PAUSE_SCHEDULED_DEBIN_REQUEST,
        params,
        formikBag,
        credentialType,
    }),

    cancelScheduledDebinSend: (params, formikBag, credentialType) => ({
        type: types.CANCEL_SCHEDULED_DEBIN_REQUEST,
        params,
        formikBag,
        credentialType,
    }),

    activateScheduledDebinSend: (params, formikBag, credentialType) => ({
        type: types.ACTIVATE_SCHEDULED_DEBIN_REQUEST,
        params,
        formikBag,
        credentialType,
    }),

    setDebinToChargeBack: (debinToChargeBack) => ({
        type: types.SET_DEBIN_TO_CHARGE_BACK,
        debinToChargeBack,
    }),

    chargeBackSend: (params, formikBag, credentialType) => ({
        type: types.CHARGE_BACK_REQUEST,
        params,
        formikBag,
        credentialType,
    }),

    chargeBackSendTrxPl: (params, formikBag, credentialType) => ({
        type: types.CHARGE_BACK_TRXPL_REQUEST,
        params,
        formikBag,
        credentialType,
    }),
};

export const selectors = {
    getAccountToChange: ({ debin }) => debin.accountToChange,
    getDebinToCancel: ({ debin }) => debin.debinToCancel,
    getSentRequests: ({ debin }) => debin.sentRequests,
    getFetching: ({ debin }) => debin.fetching,
    getDebinDetail: ({ debin }) => debin.debinDetail,
    getListCbu: ({ debin }) => debin.cbuList,
    getDebinSeller: ({ debin }) => debin.debinSeller,
    getRecipients: ({ debin }) => debin.recipients,
    getId: ({ debin }) => debin.id,
    getSummary: ({ debin }) => debin.summary,
    getAccountName: ({ debin }) => debin.accountName,
    getConcepts: ({ debin }) => debin.concepts,
    getAccounts: ({ debin }) => debin.accounts,
    getSeller: ({ debin }) => debin.seller,
    getPrestaciones: ({ debin }) => debin.prestaciones,
    getdebinPrestacionData: ({ debin }) => debin.debinPrestacion,
    getRecurrenciasDebin: ({ debin }) => debin.debinRecurrency,
    getFilterRecurrencias: ({ debin }) => debin.filterRecurrencyList,
    getRecurrencyDebinAction: ({ debin }) => debin.recurrencyDebinAction,
    getDebinObject: ({ debin }) => debin,
    getIsBackFromSummary: ({ debin }) => debin.isBackFromSummary,
    getPageToGoBack: ({ debin }) => debin.pageToGoBack,
    getBeneficiary: ({ debin }) => debin.beneficiary,
    getAddVendorAccounts: ({ debin }) => debin.addVendorAccount,
    getSolicitDebin: ({ debin }) => debin.solicitDebin,
    getScheduledDebins: ({ debin }) => debin.scheduledDebins,
    getScheduledDebin: ({ debin }) => debin.scheduledDebin,
    getDebinToChargeBack: ({ debin }) => debin.debinToChargeBack,
};
